import { render, staticRenderFns } from "./SupplierOnsiteDetail.vue?vue&type=template&id=16b4ed02&scoped=true"
import script from "./SupplierOnsiteDetail.vue?vue&type=script&lang=js"
export * from "./SupplierOnsiteDetail.vue?vue&type=script&lang=js"
import style0 from "./SupplierOnsiteDetail.vue?vue&type=style&index=0&id=16b4ed02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b4ed02",
  null
  
)

export default component.exports